import React from "react";
import { useCurrentPublicPost } from "../../hooks";
import { Title } from "..";
import { Markup } from "interweave";

export default function PublicPage() {
  const { currentPost } = useCurrentPublicPost();

  return currentPost ? (
    <>
      <Title title={currentPost.title} />
      <h1>{currentPost.title}</h1>
      <Markup content={currentPost.content} />
    </>
  ) : null;
}
